import Work1 from '../../assets/rizviinteriors.jpeg'
import Work2 from '../../assets/work2.png'
import Work3 from '../../assets/work1.png'
import Work4 from '../../assets/work4.png'
import Work5 from '../../assets/work5.png'
import Work6 from '../../assets/workn.png'

export const projectsData = [
    {
        id: 0,
        image: Work6,
        title: 'Empty Canvas',
        category: 'web',
        link: 'https://emptycanvas.in/'
    },
    {
        id: 1,
        image: Work5,
        title: 'Bronia',
        category: 'Mobile Apps',
        link: 'https://github.com/Skumail-code/Bronia'
    },
    {
        id: 2,
        image: Work1,
        title: 'Rizvi Interiors',
        category: 'web',
        link: 'https://rizviinteriors.in/'
    },

    {
        id: 3,
        image: Work3,
        title: 'ReactWeather',
        category: 'web',
        link: 'https://react-weather-app-seven-sigma.vercel.app'
    },

    {
        id: 4,
        image: Work2,
        title: 'ReactNews',
        category: 'web',
        link: 'https://github.com/Skumail-code/react'
    },

   

    {
        id: 5,
        image: Work4,
        title: 'DevLog',
        category: 'web',
        link: 'https://github.com/Skumail-code/DevLog'
    },
]

export const projectsNav = [
        {
            name: 'all',
        },
        {
            name: 'web',
        },
        {
            name: 'Mobile Apps'
        }
    ];